import React from 'react';
import PropTypes from 'prop-types';
import { TableRow, TableRowColumn } from 'material-ui/Table';
import FontIcon from 'material-ui/FontIcon';
import FlatButton from 'material-ui/FlatButton';

const styles = {
  button: {
    minWidth: 0,
  },
  buttonColumn: {
  },
};

const PanelTableRow = (props) => {
  const { item, columnStyle } = props;
  return (
    <TableRow>
      {item.fields.map(k =>
        (
          <TableRowColumn
            key={k}
            style={{ ...columnStyle, ...item[k].style }}
          >
            {item[k].value}
          </TableRowColumn>
        ))}
      {item.actions &&
        <TableRowColumn style={columnStyle}>
          {
            item.actions && item.actions.map((a, i) => {
              const icon = a.iconName ? <FontIcon className="material-icons">{a.iconName}</FontIcon> : null;
              return (
                <FlatButton
                  primary={!a.secondary && a.primary}
                  secondary={a.secondary && !a.primary}
                  key={i}
                  onClick={a.action}
                  disabled={a.disabled}
                  style={styles.button}
                  label={a.label}
                  icon={icon}
                />
              );
            })
          }
        </TableRowColumn>
      }
    </TableRow>
  );
};

PanelTableRow.propTypes = {
  item: PropTypes.object.isRequired,
  columnStyle: PropTypes.object,
};

PanelTableRow.defaultProps = {
  columnStyle: {},
};

export default PanelTableRow;



// WEBPACK FOOTER //
// ./src/components/panels/PanelTableRow.js